import { Link } from 'react-router-dom'

// #338: a card's location, as a permalink to that city's calendar.
//
// Falls back to plain text when there is no href — an event with no city has
// nothing to link to, and a dead link that looks live is worse than no link.
export default function PlaceLink({ href, children, className = '' }) {
  const body = (
    <>
      <svg className="h-4 w-4 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-7-7.5-7-12a7 7 0 1114 0c0 4.5-7 12-7 12z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
      {children}
    </>
  )
  if (!href) {
    return <span className={`inline-flex items-center gap-1.5 ${className}`}>{body}</span>
  }
  return (
    <Link to={href} className={`inline-flex items-center gap-1.5 hover:text-brand-700 hover:underline ${className}`}>
      {body}
    </Link>
  )
}
